module.exports = __webpack_public_path__ + "img/nodeTop2.6f905add.png";